export default "__VITE_ASSET__CQSR3YE___"